import { useTranslations } from 'next-intl';
import React from 'react';

interface IPlanCardProps {
  isSelected?: boolean;
  isHighlighted?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  children: React.ReactNode;
  dataTestId?: string;
}

const PlanCard: React.FC<IPlanCardProps> = ({
  children,
  isSelected = false,
  isHighlighted = false,
  onClick = () => null,
  dataTestId = '',
}) => {
  const tCheckout = useTranslations('Checkout');

  return (
    <div
      className="tw-w-full"
      data-testid={dataTestId}
      aria-selected={isSelected}
    >
      {isHighlighted ? (
        <p
          className={`
            tw-lf-body-bold-sm
            tw-flex
            tw-h-[37px]
            tw-justify-center
            tw-rounded-t-xl
            tw-bg-yellow-600
            tw-p-2
            tw-text-center
            tw-outline
            tw-outline-yellow-600
            desktop:tw-lf-body-bold-md
            desktop:tw-h-10
            ${isSelected ? ' tw-outline-[2px]' : 'tw-outline-[1px]'}
            ${
              isSelected
                ? '-tw-outline-offset-[2px]'
                : '-tw-outline-offset-[1px]'
            }
            ${isSelected ? '' : ''}
            tw-relative
          `}
        >
          {tCheckout('membershipPlanPickerPlanAnnualMostPopular')}
        </p>
      ) : null}
      <div
        className={`
        tw-lf-button-clear
        tw-relative
        -tw-mt-[1px]
        tw-flex
        tw-h-fit
        tw-w-full
        tw-flex-col
        ${isHighlighted ? 'tw-rounded-b-xl' : 'tw-rounded-xl'}
        ${isHighlighted ? 'tw-rounded-b-xl' : ''}
        ${
          isHighlighted
            ? 'tw-bg-gradient-to-bl tw-from-yellow-100/40 tw-to-transparent'
            : ''
        }
        tw-p-3
        tw-text-left
        desktop:tw-p-6
        ${isSelected ? '' : '[&_.check-icon]:tw-hidden'}
        ${
          isSelected
            ? '[&>button]:tw-lf-button-primary'
            : '[&>button]:tw-lf-button-secondary'
        }
        tw-outline
        ${
          isSelected
            ? 'tw-outline-[2px] -tw-outline-offset-[2px] tw-outline-yellow-600'
            : 'tw-outline-[1px] -tw-outline-offset-[1px] tw-outline-blue-200'
        }
      `}
        onClick={onClick}
      >
        {children}
      </div>
    </div>
  );
};

export default PlanCard;
